export default __webpack_public_path__ + "static/graphic_service_banner-40dc09bc45d6e2b37a801f504130bc2a.svg";